var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { POS_CREATE_REQUEST_START_ACTION_TYPE, POS_CREATE_REQUEST_SUCCESS_ACTION_TYPE, POS_CREATE_DEPOSIT_REQUEST_START_ACTION_TYPE, POS_CREATE_DEPOSIT_REQUEST_SUCCESS_ACTION_TYPE, POS_CANCEL_START_ACTION_TYPE, POS_CANCEL_SUCCESS_ACTION_TYPE, POS_ERROR_ACTION_TYPE, POS_RESET_ACTION_TYPE, } from "../action/PosActionsTypes";
import { PosStatus } from "./PosState";
var initialState = {
    status: PosStatus.Initial,
    loading: false,
    serviceId: undefined,
};
export var posReducer = function (state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case POS_RESET_ACTION_TYPE:
            return __assign({}, initialState);
        case POS_CREATE_REQUEST_START_ACTION_TYPE:
            return __assign(__assign({}, state), { status: PosStatus.CreatingRequest, loading: true, serviceId: undefined });
        case POS_CREATE_REQUEST_SUCCESS_ACTION_TYPE:
            return __assign(__assign({}, state), { status: PosStatus.CreateRequestSuccess, loading: false, serviceId: action.payload.serviceId });
        case POS_CREATE_DEPOSIT_REQUEST_START_ACTION_TYPE:
            return __assign(__assign({}, state), { status: PosStatus.CreatingDepositRequest, loading: true, serviceId: undefined });
        case POS_CREATE_DEPOSIT_REQUEST_SUCCESS_ACTION_TYPE:
            return __assign(__assign({}, state), { status: PosStatus.CreateDespositRequestSuccess, loading: false, serviceId: action.payload.serviceId });
        case POS_CANCEL_START_ACTION_TYPE:
            return __assign(__assign({}, state), { status: PosStatus.Canceling, loading: true });
        case POS_CANCEL_SUCCESS_ACTION_TYPE:
            return __assign(__assign({}, state), { status: PosStatus.CancelSuccess, loading: false, serviceId: undefined });
        case POS_ERROR_ACTION_TYPE:
            return __assign(__assign({}, state), { status: PosStatus.Error, loading: false });
        default:
            return state;
    }
};
export default posReducer;
